<script>
export default {
    name: "ConfirmPostDuplicateModal",
 data() {

        return {
              unpostedItems: [],
            
        };
    },
    props: {
       item: Object,
       showModal: Boolean,
     
    },

    methods: {

        saveData() {
           
            this.$root.loading=true;
                 this.$http.post(`Accounts/ManageProformaItemBill`, this.item).then(() => {
                  this.fetchInsuranceItems();
                  this.$emit(`DuplicateItem`, this.unpostedItems);
                    this.$emit('closeModalduplicate');
                    this.$root.loading=false;
                }).catch(() => {this.$root.loading=false; this.$emit('closeModalduplicate');});
        },
        
        fetchInsuranceItems() {
              this.errors = [];
                this.$root.loading=true;
                let url = `Accounts/GetPatientUnpostedProformaBillsforInsurance`;
                    url += `?PatientId=${this.item.patientID}`;
                    url += `&InsuranceID=${this.item.insuranceId}`;

                this.$http.get(url).then(({data}) => {
                    this.unpostedItems = data;
                    this.$root.loading = false;
                    
                }).catch(() => { this.$root.loading = false; });
            
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Item Select has already been Added to Invoice</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-3 text-center">
            <h5 class="font-bold text-base text-red-600">Confirm Post !</h5>{{item}}
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-8" @click="$emit('closeModalduplicate')"><i class="fa fa-times"></i> Close</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>